import React from 'react';
import { connect } from 'react-redux'

import {
  reset_dry_text
} from '../actions'

const { Modal } = window.M

const mapStateToProps = state => {
  return {
    dry: state.entry.dry
  }
}

const mapDispatchToProps = dispatch => {
  return {
    resetDry: () => dispatch( reset_dry_text() )
  }
}

class ConnectedDry extends React.Component {

  componentDidUpdate(prevProps, prevState) {

    const {dry} = this.props
    const prevDry = prevProps.dry

    if ( dry !== prevDry && dry !== null && dry !== '' && dry !== undefined ) {
      const el = document.getElementById("drymodal")
      const modal = Modal.init(el)
      modal.open()
    }
  }

  render() {
    const { dry } = this.props
    if ( dry === null || dry === '' || dry === undefined ) {
      return ''
    } else {
      return (
        <div id="drymodal" className="modal">
          <div className="modal-content">
            <h6>Operations to be performed [for multiple stages, this is estimated on current column value]</h6>
            <pre>{dry}</pre>
          </div>
          <div className="modal-footer">
            <a href="#!" className="modal-close btn waves-effect waves-green" onClick={e=>{
              e.preventDefault()
              this.props.resetDry()
            }}>Close</a>
          </div>
        </div>
      )
    }
  }
}

const Dry = connect(mapStateToProps, mapDispatchToProps)(ConnectedDry)

export default Dry



// WEBPACK FOOTER //
// ./src/js/components/Dry.js